import { I18n } from "@assets/strings";
import React, { useState } from "react";
import { useHistory } from "@core/routing/useHistory";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Group } from "@domain/group/group";
import { useShareroomLastFeedbacks } from "@domain/group/hooks";
import { PrimaryBold } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Row, stack } from "@ui/components/layout";
import { StepBubble } from "@ui/components/stepBubble";
import { mobile } from "@ui/styles/utils";
import { CustomFeedbackView } from "@ui/pages/group/shareroom/feedback/feedbackView";

interface ShareroomLastFeedbackProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const ShareroomLastFeedback: React.FC<ShareroomLastFeedbackProps> = ({ shareroom, ...htmlProps }) => {
	const { result: feedbacks, loading } = useShareroomLastFeedbacks(shareroom.id);
	const [currentStep, setCurrentStep] = useState<number>(0);
	const history = useHistory();
	return !feedbacks ? (
		loading ? (
			<ClipLoader />
		) : null
	) : (
		<>
			{feedbacks.length ? (
				<Container {...htmlProps}>
					<Row align="center" justify="space-between" style={{ width: "100%" }}>
						<StyledPrimarybold>{I18n.t("feedback.title")}</StyledPrimarybold>
						<SeeMore onClick={() => history.push(Path.Shareroom(shareroom, "feedback"))}>{I18n.t("see_more")}</SeeMore>
					</Row>

					<CustomFeedbackView key={feedbacks[currentStep].user.id} feedback={feedbacks[currentStep]} />
					<StepBubble steps={feedbacks.length} currentStep={currentStep} onClick={(i) => setCurrentStep(i)} />
				</Container>
			) : null}
		</>
	);
};

const Container = styled(RoundedBlock)`
	padding: 30px 40px;
	${stack(40)}
	align-items: normal;
	width: 100%;
	@media ${mobile} {
		padding: 20px;
	}
`;

const StyledPrimarybold = styled(PrimaryBold)`
	color: ${({ theme }) => theme.colors.secondary};
	font-size: 1.5rem;
	font-weight: 800;

	@media ${mobile} {
		font-size: 0.813rem;
	}
`;

const SeeMore = styled.div`
	${({ theme }) => theme.textStyles.text};
	flex: 1 0 auto;
	text-align: end;
	color: ${({ theme }) => theme.colors.secondary};
	cursor: pointer;
`;
